import "leaflet-draw/dist/leaflet.draw.css";
import { useEffect, type ReactNode } from "react";
import { MapContainer, useMap } from "react-leaflet";
import MapTileLayer from "../MapTileLayer";
import { ScaleControl } from "../ScaleControl";
import { FernandoNoronhaControl } from "../FernandoNoronhaControl";
import { LatLngTuple } from "leaflet";
import {
  registerMapInstance,
  unregisterMapInstance,
  createDrawingsPane,
} from "../../utils/mapRegistry";
import { MAP_MAX_ZOOM } from "../../global/constants/tiles";
import "./mapStyles.css";

function MapInstanceRegister() {
  const map = useMap();
  useEffect(() => {
    registerMapInstance(map);
    createDrawingsPane(map);
    return () => unregisterMapInstance();
  }, [map, registerMapInstance, unregisterMapInstance]);
  return null;
}

// Extended bounds to include Fernando de Noronha archipelago (-3.85, -32.42)
const PERNAMBUCO_MAX_BOUNDS: LatLngTuple[] = [
  [-10.5, -43.5],
  [-3.5, -32.0],
];

const PERNAMBUCO_CENTER: LatLngTuple = [-8.28, -35.07];

type IMapComponentProps = {
  children: ReactNode;
};

export function MapComponent({ children }: IMapComponentProps) {
  return (
    <div id="main-map">
      <MapContainer
        zoom={8}
        scrollWheelZoom={true}
        minZoom={7}
        maxZoom={MAP_MAX_ZOOM}
        zoomControl={false}
        center={PERNAMBUCO_CENTER}
        maxBounds={PERNAMBUCO_MAX_BOUNDS}
        maxBoundsViscosity={1.0}
        className="w-full mt-16 map-container h-full"
        style={{ height: "85vh", fontSize: "12px" }}
      >
        <MapInstanceRegister />
        <MapTileLayer />
        <ScaleControl position="bottomleft" maxWidth={100} />
        <FernandoNoronhaControl />
        {children}
      </MapContainer>
    </div>
  );
}
